<div class="standard-dialog dialog-feedback-wrapper">
  <fa-icon [icon]='faTimes' class="close-icon" (click)="closeDialog()"></fa-icon>
  <fa-icon [icon]='faTriangleExclamation' class="warning icon" *ngIf="type=='warning'"></fa-icon>
  <fa-icon [icon]='faCircleExclamation' class="info icon" *ngIf="type=='info'"></fa-icon>
  <fa-icon [icon]='faCircleXmark' class="error icon" *ngIf="type=='error'"></fa-icon>
  <img src="../../../assets/images/logo.png" alt="logo" *ngIf="type=='ok'">
  <p class="title">{{title}}</p>
  <p class="subtitle">{{subtitle}}</p>
  <div class="buttons-wrapper">
    <button class="action-button primary-button" (click)="closeDialog()">Aceptar</button>
  </div>
</div>